import { roundHalfUp } from '@sit/core';
export function toWeeklyBreakdownByTimeType(overtimeBreakdown) {
    const incorrectlyAppliedWeeklyBreakdownByTimeType = new Map();
    // Iterate through all days in the overtime breakdown
    for (const dayBreakdown of Object.values(overtimeBreakdown)) {
        for (const entry of dayBreakdown) {
            const existingEntry = incorrectlyAppliedWeeklyBreakdownByTimeType.get(entry.timeTypeId);
            if (existingEntry) {
                // Aggregate with existing entry for this time type
                existingEntry.currentAppliedDuration += entry.currentAppliedDuration;
                existingEntry.incorrectlyAppliedDuration +=
                    entry.overappliedDuration - entry.underappliedDuration;
            }
            else {
                // Create new entry for this time type
                incorrectlyAppliedWeeklyBreakdownByTimeType.set(entry.timeTypeId, {
                    timeTypeId: entry.timeTypeId,
                    timeTypeName: entry.timeTypeName,
                    currentAppliedDuration: entry.currentAppliedDuration,
                    incorrectlyAppliedDuration: entry.overappliedDuration - entry.underappliedDuration,
                });
            }
        }
    }
    // Convert map to array and return the correctly applied weekly breakdown
    const weeklyBreakdown = Array.from(incorrectlyAppliedWeeklyBreakdownByTimeType.values().map((entry) => ({
        ...entry,
        underappliedDuration: entry.incorrectlyAppliedDuration < 0
            ? entry.incorrectlyAppliedDuration * -1
            : 0,
        overappliedDuration: entry.incorrectlyAppliedDuration > 0
            ? entry.incorrectlyAppliedDuration
            : 0,
    })));
    return {
        weeklyBreakdown,
        hasDiscrepancies: weeklyBreakdown.some((b) => b.underappliedDuration > 0 || b.overappliedDuration > 0),
    };
}
export function formatOvertimeDuration(seconds) {
    const hours = seconds / 3600;
    return roundHalfUp(hours, 2).toFixed(2);
}
export function formatOvertimeDurationForVariance(breakdown) {
    const underOverText = breakdown.underappliedDuration > 0
        ? `-${formatOvertimeDuration(breakdown.underappliedDuration)}`
        : breakdown.overappliedDuration > 0
            ? `+${formatOvertimeDuration(breakdown.overappliedDuration)}`
            : breakdown.underappliedDuration < 0
                ? `+${formatOvertimeDuration(breakdown.underappliedDuration * -1)}`
                : breakdown.overappliedDuration < 0
                    ? `-${formatOvertimeDuration(breakdown.overappliedDuration * -1)}`
                    : '0.00';
    return underOverText;
}
//# sourceMappingURL=overtime.js.map